import { outpaintSizeOptions } from '@shakkerai/pro-models';
import React, { useEffect, useState } from 'react';
import cs from 'classnames';
const OutpaintGtnGroup = ({ onChange, image, isDisableResize }) => {
  const [{ firstBtn, restBtn }, setBtns] = useState({ firstBtn: [], restBtn: [] });
  const [defValue, setDefValue] = useState();

  useEffect(() => {
    const { width, height } = image?.outpaintRect?.wrapper ?? {};
    const target = outpaintSizeOptions.find((op) => op.value === (width / height).toFixed(2));
    setDefValue(target ? target.value : null);
  }, [image]);

  useEffect(() => {
    const firstBtn = [];
    const restBtn = [];
    outpaintSizeOptions.forEach(({ width, height }) => {
      (width === 1 && height === 1 ? firstBtn : restBtn).push({
        text: `${width}:${height}`,
        value: (width / height).toFixed(2),
      });
    });
    setBtns({ firstBtn, restBtn });
  }, []);
  const setValue = (value) => {
    setDefValue(value);
    onChange(value);
  };

  const setCurValue = (value) => {
    if (isDisableResize) return;
    setValue(value);
  };

  return (
    <div className="flex mt-3">
      <div className="w-[62px] h-[52px] flex-shrink-0 rounded-sm cursor-pointer">
        {firstBtn.map(({ text, value }, idx) => {
          return (
            <div
              onClick={() => setCurValue(value)}
              key={idx}
              className={cs(
                `${value === defValue ? 'bg-primary/10 border-primary' : 'border-transparent bg-[##F3F5F7]'}`,
                `${isDisableResize ? 'cursor-not-allowed text-[#adadad]' : 'cursor-pointer'}`,
                '  border flex h-full rounded-sm justify-center items-center bg-[#F4F6F8] text-xs',
              )}
            >
              {text}
            </div>
          );
        })}
      </div>
      <div className="flex-grow flex text-center flex-wrap">
        {restBtn.map(({ text, value }, idx) => {
          return (
            <div
              key={idx}
              onClick={() => setCurValue(value)}
              className={cs(
                `border flex justify-center items-center w-[62px] rounded-sm h-[24px] ml-1 bg-[#F4F6F8] text-xs ${
                  idx > 2 ? 'mt-1' : ''
                }`,
                `${isDisableResize ? ' cursor-not-allowed text-[#adadad]' : 'cursor-pointer'}`,
                `${value === defValue ? 'bg-primary/10 border-primary' : 'border-transparent bg-[##F3F5F7]'}`,
              )}
            >
              {text}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OutpaintGtnGroup;
